export default __webpack_public_path__ + "static/media/horizontal-split.52eb5ff8.svg";